// extracted by mini-css-extract-plugin
export default {"searchInput":"SearchInput_searchInput__URs3Y","clearSearchIcon":"SearchInput_clearSearchIcon__qwxmJ"};